import React, { useState } from 'react';
import proptypes from 'prop-types';
import { Tile, TileMedia, TileText, TileContent } from '@one-thd/sui-atomic-components';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { useImpression } from '@thd-olt-component-react/impression';
import { TooltipContent } from '../tooltip-content/tooltip-content';

const {
  bool, func, oneOf,
  shape, string, number
} = proptypes;

const getTitle = (shouldShowTooltip, value) => (shouldShowTooltip ? '' : value);

const shouldShowImpressionData = (index, isImpressionsRequired,
  isHovered, isClickedMobile) => (index !== 0 && isImpressionsRequired && (isHovered || isClickedMobile));

export const Swatch = (props) => {
  const {
    channel,
    displayInToolTip,
    hoveredCombinationDetails,
    isAvailable,
    isSelected,
    isTooltipsEnabled,
    miniSwatch,
    onClick,
    onMouseEnter,
    onMouseLeave,
    swatchGuid,
    size,
    value,
    index,
    swatchItemId,
    componentImpressionData,
    isImpressionsRequired,
  } = props;
  const [isHovered, setIsHovered] = useState(false);
  const [isClickedMobile, setIsClickedMobile] = useState(false);

  const isMobile = channel === 'mobile';

  const shouldShowTooltip = isHovered
    && isTooltipsEnabled && hoveredCombinationDetails?.combinationDetails && !miniSwatch;
  const title = getTitle(shouldShowTooltip, value);

  const mouseEnter = (event) => {
    if (!isMobile) {
      setIsHovered(true);
      onMouseEnter(event);
    }
  };
  const mouseLeave = (event) => {
    if (!isMobile) {
      setIsHovered(false);
      onMouseLeave(event);
    }
  };

  const impressionProviderContextData = useImpression({
    data: {
      id: swatchItemId || '',
      name: componentImpressionData?.name || '',
      component: componentImpressionData?.component || '',
      position: componentImpressionData?.position || 1,
      type: componentImpressionData?.type || '',
      category: 'ssku'
    }
  });

  const onClickMobile = () => {
    if (isMobile) {
      setIsClickedMobile(true);
    }
  };

  const isShowImpressionData = shouldShowImpressionData(index, isImpressionsRequired, isHovered, isClickedMobile);

  const swatchChild = (
    <div
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      ref={
        isShowImpressionData
          ? impressionProviderContextData.ref
          : null
      }
      // eslint-disable-next-line react/no-unknown-property
      clickid={isShowImpressionData ? impressionProviderContextData.clickID : undefined}
    >
      <Tile
        value={value}
        aria-label={value}
        selected={isSelected}
        unavailable={!isSelected && !isAvailable && !miniSwatch}
        onClick={(event) => {
          onClick(event);
          onClickMobile();
        }}
      >
        <TileContent>
          <TileMedia
            alt={value}
            height="7"
            src={swatchGuid}
            loading="lazy"
          />
          {displayInToolTip && <TileText>{title}</TileText>}
        </TileContent>
      </Tile>
    </div>

  );
  return (shouldShowTooltip
    ? (
      <Tooltip
        channel={channel}
        content={<TooltipContent hoveredCombinationDetails={hoveredCombinationDetails} />}
        interactive
      >
        {swatchChild}
      </Tooltip>
    )
    : (swatchChild)
  );
};

Swatch.displayName = 'Swatch';

Swatch.propTypes = {
  channel: oneOf(['desktop', 'mobile']).isRequired,
  displayInToolTip: bool,
  hoveredCombinationDetails: shape({}),
  isAvailable: bool.isRequired,
  isSelected: bool.isRequired,
  isTooltipsEnabled: bool,
  miniSwatch: bool,
  onClick: func.isRequired,
  onMouseEnter: func.isRequired,
  onMouseLeave: func.isRequired,
  size: string,
  swatchGuid: string.isRequired,
  value: string.isRequired,
  swatchItemId: string,
  index: number,
  componentImpressionData: shape({
    name: string,
    component: string,
    position: number,
    type: string,
  }),
  isImpressionsRequired: bool,
};

Swatch.defaultProps = {
  displayInToolTip: false,
  hoveredCombinationDetails: {},
  miniSwatch: false,
  isTooltipsEnabled: false,
  size: null,
  swatchItemId: null,
  index: 0,
  componentImpressionData: {
    name: '',
    component: '',
    position: 1,
    type: '',
  },
  isImpressionsRequired: false,
};
